import { inventoryPricingSlice } from '../slices/inventoryPricingSlice';

export default inventoryPricingSlice.reducer;
